



































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';


/**
 * Composant de représentation d'un item sous forme de carte.
 */
@Component
export default class ShopItemCard extends Vue {
	/** Propriétés */
	// Un item
	@Prop()
	item!: any;

	@Prop()
	itemInCart!: any;

	@Prop()
	handleItemAddClick!: (itemId: number,itemType: number) => Promise<void>;

	@Prop()
	handleItemRemoveClick!: (itemId: number,formulaNum: number|null) => Promise<void>;

	@Prop()
	isFormulaItem!: boolean ;


	/** Attributs */
	isActionLoading: boolean = false;
		
	/** Méthodes */
	async onItemAddClick(itemId: number,itemType: number) {
		this.isActionLoading = true;
		try {
			await this.handleItemAddClick(itemId, itemType);
			this.isActionLoading = false;
		}
		catch (error) {
			this.isActionLoading = false;
			throw error;
		}
	}
	async onItemRemoveClick(itemId: number) {
		this.isActionLoading = true;
		try {
			await this.handleItemRemoveClick(itemId,null);
			this.isActionLoading = false;
		}
		catch (error) {
			this.isActionLoading = false;
			throw error;
		}
	}

}
